/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { type ReactNode } from 'react';
import { SnippetsSection } from '../Snippets/SnippetsSection';
import { Text } from './Text';
import { SECTION_NAME_WELCOME } from '../../../constants/snippetsSectionNames';

export function SnippetsWelcomeSection(): ReactNode {
	return (
		<SnippetsSection
			headerCharacter={ '🎉' }
			title={ SECTION_NAME_WELCOME }
		>
			<Text>
				Great job! You finished building your CKEditor.
				Follow the steps below to set it up locally and start integrating text editing experience into your application.
			</Text>
		</SnippetsSection>
	);
}
